<template>
    <div class="page-container">
        <el-card shadow="never" class="main-card">
            <!-- 查询条件区 + 操作按钮 -->
            <div class="search-bar">
                <el-select v-model="queryCon.dicType" placeholder="字典类型" style="width:200px;">
                    <el-option v-for="item in dicTypeData" :key="item.dicTypeCode" :label="item.dicTypeName"
                        :value="item.dicTypeCode" />
                </el-select>
                <el-button-group>
                    <el-button type="primary" :icon="Search" @click="handler.queryHandler">查询</el-button>
                    <el-button :icon="RefreshRight" @click="resetQueryCon">重置</el-button>
                </el-button-group>
                <div class="action-bar">
                    <el-button type="primary" plain :icon="CirclePlusFilled" @click="handler.addHandler">新增</el-button>
                    <el-button type="danger" plain :icon="Delete" @click="handler.deleteBatchHandler">删除</el-button>
                </div>
            </div>

            <!-- 表格区 -->
            <div class="table-wrapper">
                <el-table :data="tableData" v-loading="tableLoading" height="100%" row-key="id" ref="dataTableRef"
                    class="modern-table"
                    :header-cell-style="{ background: '#fafafa', color: '#909399', fontWeight: 500 }">
                    <el-table-column type="selection" width="40" />
                    <el-table-column prop="dicLabel" label="字典项显示文本" />
                    <el-table-column prop="dicVal" label="字典项值" />
                    <el-table-column prop="modifyName" label="修改人" width="100" />
                    <el-table-column prop="modifyDate" label="修改日期" width="180" />
                    <el-table-column label="操作" width="110" fixed="right" header-align="center">
                        <template #default="scope">
                            <el-button size="small" circle :icon="Edit" @click="handler.editHandler(scope.row)" />
                            <el-button size="small" circle type="danger" :icon="Delete" @click="handler.deleteHandler(scope.row)" />
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页 -->
            <div class="pagination-wrapper">
                <el-pagination background v-model:current-page="queryCon.currentPage" v-model:page-size="queryCon.pageSize"
                    :page-sizes="pagination.pageInfo.pageSizes" layout="total, sizes, prev, pager, next"
                    :total="pagination.pageInfo.total" @size-change="pagination.handleSizeChange"
                    @current-change="pagination.handleCurrentChange" />
            </div>
        </el-card>

        <el-dialog v-model="dialogFormVisible" title="新建/编辑" width="800">
            <el-form :inline="true" :model="form" :label-position="top" label-width="auto" :rules="rules" status-icon
                ref="dataFormRef">
                <el-form-item v-show="false" label="id" prop="id">
                    <el-input v-model="form.id"></el-input>
                </el-form-item>
                <el-form-item label="字典项类型" prop="dicType">
                    <el-select v-model="form.dicType" class="el-input-width">
                        <el-option v-for="item in dicTypeData" :key="item.dicTypeCode" :label="item.dicTypeName"
                            :value="item.dicTypeCode" />
                    </el-select>
                </el-form-item>
                <el-form-item label="字典项名称" prop="dicLabel">
                    <el-input v-model="form.dicLabel" autocomplete="off" class="el-input-width" />
                </el-form-item>
                <el-form-item label="字典项值/代码" prop="dicVal">
                    <el-input v-model="form.dicVal" autocomplete="off" class="el-input-width" />
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取消</el-button>
                    <el-button type="primary" @click="handler.saveHandler">保存</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<style lang="css" scoped>
@import '../../../src/assets/styles/common.css';
</style>

<script setup>
import { nextTick, ref, reactive, onMounted } from 'vue';
import "@/assets/styles/crud-page.css";
import { ElTable, ElMessageBox, ElMessage, ElSelect, ElOption } from 'element-plus';
import 'element-plus/dist/index.css';
import { Delete, CirclePlusFilled, Search, Edit, RefreshRight } from "@element-plus/icons-vue";
import { dictionaryApi } from "@/api/dict-api.js";
import { dictionaryTypeApi } from "@/api/dict-type-api.js";

//弹出框状态
const dialogFormVisible = ref(false);
const tableLoading = ref(false);

//数据
const tableData = ref([]);
const dicTypeData = ref([]);

//引用
const dataTableRef = ref(null);
const dataFormRef = ref(null);

//查询条件、分页处理
const queryCon = reactive({ dicType: "", pageSize: 10, currentPage: 1 })

const resetQueryCon = () => {
    if (dicTypeData.value.length > 0) {
        queryCon.dicType = dicTypeData.value[0].dicTypeCode;
    }
    queryCon.pageSize = 10;
    queryCon.currentPage = 1;
}

const pagination = {
    pageInfo: reactive({
        total: 0,
        pageSizes: [10, 20, 30, 50, 100]
    }),
    handleSizeChange: (val) => {
        queryCon.pageSize = val;
        handler.queryHandler();
    },
    handleCurrentChange: (val) => {
        queryCon.currentPage = val;
        handler.queryHandler();
    }
}

//表单对象
const form = reactive({
    id: null,
    dicType: '',
    dicLabel: '',
    dicVal: ''
});
const rules = {
    dicType: [{ required: true, message: "请选择字典项类型", trigger: 'blur' }],
    dicLabel: [{ required: true, message: "字典项名称不能为空", trigger: 'blur' }],
    dicVal: [{ required: true, message: "字典项值/代码不能为空", trigger: 'blur' }]
};
const resetForm = () => {
    dataFormRef.value?.resetFields();
};

//初始化数据
async function init() {
    const { data } = await dictionaryTypeApi.listDictType();
    dicTypeData.value = data.result || [];
    if (dicTypeData.value.length > 0) {
        queryCon.dicType = dicTypeData.value[0]?.dicTypeCode;
    }
}

//生命周期
onMounted(async () => {
    await init();
    handler.queryHandler();
});

//UI界面逻辑
const handler = {
    queryHandler() {
        tableLoading.value = true;
        dictionaryApi.pageDict(queryCon).then((response) => {
            if (response.data.errorCode === "00000") {
                tableData.value = response.data.result.records;
                pagination.pageInfo.total = response.data.result.total;
            } else {
                ElMessage.error(`操作失败，${response.data.errorMessage}, [错误码:${response.data.errorCode}]`);
            }
        }).finally(function () {
            tableLoading.value = false;
        });
    },
    addHandler() {
        resetForm();
        dialogFormVisible.value = true;
    },
    editHandler(rowObj) {
        resetForm();
        dialogFormVisible.value = true;
        nextTick(() => {
            Object.assign(form, rowObj);
        })
    },
    deleteHandler(rowObj) {
        ElMessageBox.confirm(
            '确认要删除吗?',
            '删除确认',
            {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
            }
        ).then(() => {
            dictionaryApi.deleteDict([rowObj.id])
                .then((response) => {
                    if (response.data.errorCode === "00000") {
                        ElMessage({ message: '删除成功.', type: 'success' });
                        handler.queryHandler();
                    } else {
                        ElMessage.error(`操作失败，${response.data.errorMessage}, [错误码:${response.data.errorCode}]`);
                    }
                })
        }).catch(() => {})
    },
    deleteBatchHandler() {
        var selectedRows = dataTableRef.value.getSelectionRows();
        if (selectedRows && selectedRows.length == 0) { ElMessage("没有选中任何行"); return; }

        var ids = [];
        selectedRows.forEach(function (item) {
            ids.push(item.id);
        });

        ElMessageBox.confirm(
            '确认要删除吗?',
            '删除确认',
            {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
            }
        )
            .then(() => {
                dictionaryApi.deleteDict(ids)
                    .then((response) => {
                        if (response.data.errorCode === "00000") {
                            ElMessage({ message: '删除成功.', type: 'success' });
                            handler.queryHandler();
                        } else {
                            ElMessage.error(`操作失败，${response.data.errorMessage}, [错误码:${response.data.errorCode}]`);
                        }
                    })
            }).catch(() => { })
    },
    saveHandler() {
        dataFormRef.value.validate((valid) => {
            if (valid) {
                dictionaryApi.saveDict(form).then((response) => {
                    if (response.data.errorCode === "00000") {
                        ElMessage({ message: '保存成功', type: 'success' });
                        handler.queryHandler();
                        dialogFormVisible.value = false;
                    } else {
                        ElMessage.error(`操作失败，${response.data.errorMessage}, [错误码:${response.data.errorCode}]`);
                    }
                })
            }
        });
    }
}
</script>
